import { ILimits } from './interfaces';

export const getLowestLimit = (limits: ILimits) => {
  const arrayOfObjects = Object.keys(limits)
    .map(key => ({
      key,
      value: limits[key as keyof typeof limits],
    }));
  return arrayOfObjects.sort((a, b) => a.value - b.value)[0];
};
